import { Button, Typography } from '@speeki/global-ui-components';

import { StatisticsCardEmptyStateWrapper } from './StatisticsCardEmptyState.styled';

interface StatisticsCardEmptyStateProps {
    action: {
        label: string;
        onClick: () => void;
    };
    children?: React.ReactNode;
}

export const StatisticsCardEmptyState = ({
    action,
    children,
}: StatisticsCardEmptyStateProps) => {
    return (
        <StatisticsCardEmptyStateWrapper>
            <Typography.TextBody_16_24>{children}</Typography.TextBody_16_24>
            <Button
                iconProps={{
                    icon: 'SvgAddNew24',
                    size: 24,
                    themeColors: {
                        default: {
                            'color-1': 'secondary.default',
                        },
                    },
                }}
                onClick={action.onClick}
                size="small"
                testId="UlBi4iG"
                variant="secondary"
            >
                {action.label}
            </Button>
        </StatisticsCardEmptyStateWrapper>
    );
};
